import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Button, Form, FormGroup, Label, Input, Alert, FormFeedback} from 'reactstrap';
import classnames from 'classnames';

import DateTime from 'react-datetime';
import moment from 'moment';

import { ButtonWithLoader } from '../../../core';
import { countryCodes } from '../../../core/helpers/country-codes';
import { utils } from '../../../core/helpers/utils';

class PersonalDetailsForm extends Component {
  constructor(props) {
    super(props);
    if(props && props.data) {
      this.state = {
        errors: {},
        cob: 'India',
        nationality: "Indian",
        ...props.data
      }  
    } else {
      this.state = {
        errors: {}
      };
    }

    this.submitPersonalDetails = this.submitPersonalDetails.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps && nextProps.data) {
      this.setState({
        ...nextProps.data
      })
    }
  }

  componentWillMount() {
    // if(this.props.data) {

    // }
    // this.setState(this.props.data);
  }

  submitPersonalDetails(e) {
    e.preventDefault();

    this.submit(false);
    
  }

  submit(shouldMoveNext) {
    this.setState({
      submitting: true
    });
    let firstName = this.state.firstName && this.state.firstName.trim();
    let lastName = this.state.lastName && this.state.lastName.trim();
    let fName =  this.state.fName && this.state.fName.trim();
    let gender = this.state.gender && this.state.gender.trim();
    let pob = this.state.pob && this.state.pob.trim();
    let nationality = this.state.nationality && this.state.nationality.trim();
    let cob = this.state.cob && this.state.cob.trim();
    let mobile = this.state.mobile && this.state.mobile.trim();

    // console.log(Boolean(!this.state.name || !this.state.fName || !this.state.gender  || !this.state.nationality || !this.state.pob))
    if (!firstName || !lastName || !fName || !gender || !pob || !nationality || !cob || !mobile){

      var  errors = {};

      if (!firstName) {
          errors["firstName"]= "please enter you first name!";
      }

      if (!lastName) {
        errors["lastName"]= "please enter you last name!";
    }

      if (!fName) {
        errors["fName"]= "please enter you father's name!";
      }

      if (!gender) {
        errors["gender"]= "please select your gender.";
      }

      if (!pob) {
        errors["pob"]= "please enter you place of birth";
      }

      if (!nationality) {
        errors["nationality"]= "please select you nationality";
      }

      if (!cob) {
        errors["cob"]= "please select you country of birth";
      }

      if (!mobile) {
        errors["mobile"]= "please enter your mobile no";
      }

      if (!utils.validatePhone(mobile)) {
        errors["mobile"]= "please enter correct mobile no";
      }

      this.setState({
        errors: errors,
        submitting: false
      });
    } else {
      var errors = {};
      if (!utils.validatePhoneStartLetter(mobile)) {
        errors["mobile"]= "Mobile Number should start with 6,7,8 or 9";
        this.setState({
          errors: errors,
          submitting: false
        });
        return;
      }
      if (this.state.mobile.length !== 10) {
        errors["mobile"] = "Mobile number should be 10 characters only";
        this.setState({
          errors: errors,
          submitting: false
        });
      } else {
        this.setState({
          errors: {},
          submitting: false
        });
        var personalDetails = {
          name: this.state.firstName + " " + this.state.lastName,
          fName: this.state.fName,
          gender: this.state.gender,
          pob: this.state.pob,
          nationality: this.state.nationality,
          cob: this.state.cob,
          mobile: this.state.mobile
        }
        this.props.submit('personalDetails', personalDetails, shouldMoveNext);
      }
    }
  }

  render() {
    return (
      <Form className="login-form" onSubmit={this.submitPersonalDetails}>
        <FormGroup>
          <Label for="firstName" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.firstName })} >
                  First name
          </Label>

          <Input type="text" 
                 name="firstName" 
                 id="firstName" 
                 className="form-control font-weight-semi-bold"
                 placeholder="First name" 
                 onChange={e => this.setState({firstName: e.target.value})}
                 value={this.state.firstName}
                 invalid={this.state.errors.firstName}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.firstName || this.state.errors.firstName.length === 0) })}>
              {this.state.errors.firstName}
          </FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="name" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.lastName })} >
                  Last name
          </Label>
          <Input type="text" 
                 name="name" 
                 id="name" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Last Name" 
                 onChange={e => this.setState({lastName: e.target.value})}
                 value={this.state.lastName}
                 invalid={this.state.errors.lastName}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.lastName || this.state.errors.lastName.length === 0) })}>
              {this.state.errors.lastName}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="fathersName" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.fName })} >
                  Father's name
          </Label>

          <Input type="text" 
                 name="fathersName" 
                 id="fathersName" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Father's name" 
                 onChange={e => this.setState({fName: e.target.value})}
                 value={this.state.fName}
                 invalid={this.state.errors.fName}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.fName || this.state.errors.fName.length === 0) })}>
              {this.state.errors.fName}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="fathersName" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.mobile })} >
                  Phone
          </Label>

          <Input type="number" 
                 name="mobileNO" 
                 id="mobileNO" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Mobile No" 
                 onChange={e => this.setState({mobile: e.target.value})}
                 value={this.state.mobile}
                 invalid={this.state.errors.mobile}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.mobile || this.state.errors.mobile.length === 0) })}>
              {this.state.errors.mobile}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="gender" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.gender })} >
                  Gender
          </Label>

          <select className="custom-select border-bottom border-1 form-control" 
                  id="gender" 
                  name="gender" 
                  value={this.state.gender}
                  onChange={e => this.setState({gender: e.target.value})}
                  >
                    <option value="" key="none">Gender</option>
                    <option value="Male" key="Male">Male</option> 
                    <option value="Female" key="Female">Female</option>
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.gender || this.state.errors.gender.length === 0) })}>
            {this.state.errors.gender}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="pob" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.pob })} >
                  Place of birth
          </Label>

          <Input type="text" 
                 name="pob" 
                 id="pob" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Place of birth" 
                 onChange={e => this.setState({pob: e.target.value})}
                 value={this.state.pob}
                 invalid={this.state.errors.pob}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.pob || this.state.errors.pob.length === 0) })}>
            {this.state.errors.pob}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="nationality" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.nationality })} >
                  Nationality
          </Label>

          {/* <Input type="text" 
                 name="nationality" 
                 id="nationality" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Nationality" 
                 onChange={e => this.setState({nationality: e.target.value})}
                 value={this.state.nationality}
                 /> */}
          <select className="custom-select border-bottom border-1 form-control" 
                  id="nationality" 
                  name="nationality" 
                  value={this.state.nationality}
                  onChange={e => this.setState({nationality: e.target.value})}
                  >
                    <option value="" key="none">Nationality</option>
                    {countryCodes.map(country => (
                        <option value={country.nationality} key={country.nationality}>{country.nationality}</option> 
                      ))} 
                  </select>

          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.nationality || this.state.errors.nationality.length === 0) })}>
            {this.state.errors.nationality}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="cob" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.cob })} >
                  Country of birth
          </Label>

          {/* <Input type="text" 
                 name="cob" 
                 id="cob" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Country of birth" 
                 onChange={e => this.setState({cob: e.target.value})}
                 value={this.state.cob}
                 /> */}
          <select className="custom-select border-bottom border-1 form-control" 
                  id="cob" 
                  name="cob" 
                  value={this.state.cob}
                  onChange={e => this.setState({cob: e.target.value})}
                  >
                    <option value="" key="none">Country of birth</option>
                    {countryCodes.map(country => (
                        <option value={country.name} key={country.name}>{country.name}</option> 
                      ))} 
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.cob || this.state.errors.cob.length === 0) })}>
            {this.state.errors.cob}
          </FormFeedback>
        </FormGroup>

        <FormGroup className="cta-block">
          {/* <ButtonWithLoader 
                text="Save" 
                isLoading={this.props.isSubmittingPersonal} 
                color="primary" 
                className="w-100 mb-3"
                /> */}

          <ButtonWithLoader 
                text="Next" 
                isLoading={this.state.submitting} 
                className="w-100 btn-outline-dark"
                onClick={() => this.submit(true)}
                />
        </FormGroup>
      </Form>  
    );
  }
}

export default PersonalDetailsForm; 